import { EraControllerApi, EraRequest } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface Params {
  eraRequest: EraRequest;
}

export const useCreateEra = () =>
  useMutationWithLoading(async (params: Params) =>
    new EraControllerApi(getConfigObject()).createEra(
      params.eraRequest,
      getXtenantId()
    )
  );
